import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/type-configuration.svg
 */
const IconTypeConfiguration: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M.88 5.768c.618 0 1.21-.019 1.809-.025a2.608 2.608 0 002.493 2.052h.03a2.602 2.602 0 001.852-.846c.32-.344.546-.763.657-1.22 2.98 0 5.733.06 8.368.142h.027a.852.852 0 00.023-1.704 324.45 324.45 0 00-8.552-.141A2.38 2.38 0 005.432 2.56a2.767 2.767 0 00-2.513 1.474c-.69 0-1.369 0-2.076.03A.852.852 0 10.86 5.767h.02zm4.51-1.503c.328 0 .7.161.733.816a.988.988 0 01-.286.7.914.914 0 01-.632.31.87.87 0 01-.628-.33.81.81 0 01-.23-.614 1.018 1.018 0 011.029-.882h.013zM22.896 3.974a18.722 18.722 0 01-3.06.022.86.86 0 00-.87 1.12.845.845 0 00.746.581 20.536 20.536 0 003.335-.026.852.852 0 00.737-.594.854.854 0 00-.266-.909.853.853 0 00-.622-.194zM7.746 17.667a2.388 2.388 0 00-2.158-1.465 2.722 2.722 0 00-2.516 1.475c-.688 0-1.372 0-2.066.026a.853.853 0 000 1.704h.016c.606 0 1.201 0 1.803-.023A2.63 2.63 0 005.32 21.44h.033a2.631 2.631 0 001.848-.85c.322-.342.548-.762.658-1.219 2.96 0 5.717.06 8.364.142h.027a.853.853 0 00.026-1.704 309.76 309.76 0 00-8.529-.142zm-1.77 1.756a.92.92 0 01-.632.31.875.875 0 01-.628-.33.804.804 0 01-.226-.615 1.004 1.004 0 011.016-.898h.03c.328 0 .703.162.733.816a.988.988 0 01-.293.717zM23.044 17.614c-1.018.09-2.04.097-3.06.023a.862.862 0 00-.91.79.847.847 0 00.786.91 20.517 20.517 0 003.335-.025.857.857 0 00.578-.302.857.857 0 00.102-.941.859.859 0 00-.5-.42.856.856 0 00-.331-.035zM23.12 10.944c-2.379.08-4.684.076-6.908.076h-2.474a2.382 2.382 0 00-2.302-1.849 2.712 2.712 0 00-2.697 1.918c-1.076 0-2.135-.001-3.244-.024-1.506-.033-3.062-.066-4.67 0a.854.854 0 00-.591.276.848.848 0 00.057 1.201.86.86 0 00.613.224c1.555-.07 3.078-.037 4.555 0 .833.016 1.681.037 2.536.037h.836c.11.268.265.515.457.732a2.55 2.55 0 001.892.879h.032a2.63 2.63 0 001.852-.849c.226-.243.407-.525.536-.832h2.599c2.243 0 4.569 0 6.98-.078a.853.853 0 00-.063-1.704l.003-.007zM11.191 12.71a.864.864 0 01-.624-.311.823.823 0 01-.23-.615 1.003 1.003 0 011.016-.901h.03c.328 0 .703.164.733.819.001.26-.1.51-.283.697a.912.912 0 01-.642.311z"
      fill="currentColor"
    />
  </svg>
);

export default IconTypeConfiguration;
